// Generated by `./sensika nomenclature:export-view-ids` from the nom_view_preset_view and nom_view_preset_view_type nomenclatures.
// Do not edit: register the view in the backend nomenclature, then regenerate.
export enum ViewId {
  /** Fallback view id for presets without a dedicated view */
  Default = 'default',
  Users = 'ag-users',
  Roles = 'ag-roles',
  UserGroups = 'ag-userGroups',
  Companies = 'ag-companies',
  Feeds = 'ag-feeds',
  Alerts = 'ag-alerts',
  /** The user's own My Schedules grid */
  ExportSchedules = 'ag-schedules',
  ActivityLog = 'ag-activity-log',
  SearchLog = 'ag-search-log',
  OutputLog = 'ag-output-log',
  SynopsisLog = 'ag-synopsis-log',
  DeveloperApiCompanyList = 'ag-developer-api-company-list',
  DeveloperApiCompanyUsageList = 'ag-developer-api-company-usage-list',
  PlatformIdentities = 'ag-platform-identities',
  Categories = 'ag-categories',
  Dashboards = 'ag-dashboards',
  Dimensions = 'ag-dimensions',
  HomeViewObjects = 'hv-objects',
  WorkspaceViewObjects = 'wv-objects',
  PanelViewWidgets = 'pv-widgets',
  PanelLanguageWidgets = 'pv-lang-widgets',
  PaneViewFeedResults = 'pv-feed-results',
  PaneViewStoryPosts = 'pv-story-posts',
  ObjectViewDashboard = 'ov-dashboard',
  ObjectViewDashboardPage = 'ov-dashboard-page',
  ExportTemplates = 'ag-export-templates',
  AutoStoryRuns = 'ag-auto-story-runs',
  ImportContentLogs = 'ag-import-content-logs',
  HttpRequestLog = 'ag-http-request-log',
  DataProviders = 'ag-data-providers',
  DataProviderHarvestLog = 'ag-data-provider-harvest-log',
  EngineSchedules = 'ag-engine-schedules',
  EngineScheduleRuns = 'ag-engine-schedule-runs',
  Sitemaps = 'ag-sitemaps',
  ObjectProperties = 'ag-object-properties',
  HelpManager = 'ag-help-manager',
  NomenclatureManagement = 'ag-nomenclature-management',
  /** Client Admin -> Export Schedules; distinct from the user's own My Schedules */
  AdminExportSchedules = 'ag-admin-export-schedules',
  /** Query editor -> Used By popup grid; distinct from the Feeds view it resembles */
  QueryUsedBy = 'ag-query-used-by',
  Connectors = 'ag-connectors',
  Rules = 'ag-rules',
  /** The rules grid routed under one connector - its own presets, the Connector column hidden */
  ConnectorRules = 'ag-connector-rules',
  /** Admin module -> View Presets management grid (SEN-5223 / WAP-1638) */
  ViewPresets = 'ag-view-presets',
  /** Admin module -> Output Settings management grid (SEN-5223 / WAP-1638) */
  OutputSettings = 'ag-output-settings',
  /** SysAdmin module -> Cron Jobs list grid (SEN-5285) */
  CronJobs = 'ag-cron-jobs',
  /** SysAdmin module -> Admin operations ledger grid (WAP-1702) */
  AdminOperations = 'ag-admin-operations',
  /** SysAdmin module -> Solr Servers live status grid (WAP-1737) */
  SolrServers = 'ag-solr-servers',
  /** SysAdmin module -> Infrastructure Hosts grid over the host inventory (WAP-1752) */
  InfraHosts = 'ag-infra-hosts',
  /** SysAdmin module -> Infrastructure Findings grid over the findings ledger (HOF-002) */
  InfraHostFindings = 'ag-infra-host-findings',
  /** SysAdmin module -> Log Event Stats grid over the per-minute log severity counts (SEN-5454) */
  LogEventStats = 'ag-log-event-stats',
  /** Frontend view `ov-main-menu`: the main menu state per user - pinned mode, bar collapse and collapsed groups (WAP-1706) */
  ObjectViewMainMenu = 'ov-main-menu',
}

export enum ViewType {
  Fallback = 'fallback',
  AgGrid = 'ag_grid',
  PanelView = 'panel_view',
  HomeView = 'home_view',
  WorkspaceView = 'workspace_view',
  ObjectView = 'object_view',
}

export const VIEW_TYPE_BY_VIEW_ID: Readonly<Record<ViewId, ViewType>> = {
  [ViewId.Default]: ViewType.Fallback,
  [ViewId.Users]: ViewType.AgGrid,
  [ViewId.Roles]: ViewType.AgGrid,
  [ViewId.UserGroups]: ViewType.AgGrid,
  [ViewId.Companies]: ViewType.AgGrid,
  [ViewId.Feeds]: ViewType.AgGrid,
  [ViewId.Alerts]: ViewType.AgGrid,
  [ViewId.ExportSchedules]: ViewType.AgGrid,
  [ViewId.ActivityLog]: ViewType.AgGrid,
  [ViewId.SearchLog]: ViewType.AgGrid,
  [ViewId.OutputLog]: ViewType.AgGrid,
  [ViewId.SynopsisLog]: ViewType.AgGrid,
  [ViewId.DeveloperApiCompanyList]: ViewType.AgGrid,
  [ViewId.DeveloperApiCompanyUsageList]: ViewType.AgGrid,
  [ViewId.PlatformIdentities]: ViewType.AgGrid,
  [ViewId.Categories]: ViewType.AgGrid,
  [ViewId.Dashboards]: ViewType.AgGrid,
  [ViewId.Dimensions]: ViewType.AgGrid,
  [ViewId.HomeViewObjects]: ViewType.HomeView,
  [ViewId.WorkspaceViewObjects]: ViewType.WorkspaceView,
  [ViewId.PanelViewWidgets]: ViewType.PanelView,
  [ViewId.PanelLanguageWidgets]: ViewType.PanelView,
  [ViewId.PaneViewFeedResults]: ViewType.PanelView,
  [ViewId.PaneViewStoryPosts]: ViewType.PanelView,
  [ViewId.ObjectViewDashboard]: ViewType.ObjectView,
  [ViewId.ObjectViewDashboardPage]: ViewType.ObjectView,
  [ViewId.ExportTemplates]: ViewType.AgGrid,
  [ViewId.AutoStoryRuns]: ViewType.AgGrid,
  [ViewId.ImportContentLogs]: ViewType.AgGrid,
  [ViewId.HttpRequestLog]: ViewType.AgGrid,
  [ViewId.DataProviders]: ViewType.AgGrid,
  [ViewId.DataProviderHarvestLog]: ViewType.AgGrid,
  [ViewId.EngineSchedules]: ViewType.AgGrid,
  [ViewId.EngineScheduleRuns]: ViewType.AgGrid,
  [ViewId.Sitemaps]: ViewType.AgGrid,
  [ViewId.ObjectProperties]: ViewType.AgGrid,
  [ViewId.HelpManager]: ViewType.AgGrid,
  [ViewId.NomenclatureManagement]: ViewType.AgGrid,
  [ViewId.AdminExportSchedules]: ViewType.AgGrid,
  [ViewId.QueryUsedBy]: ViewType.AgGrid,
  [ViewId.Connectors]: ViewType.AgGrid,
  [ViewId.Rules]: ViewType.AgGrid,
  [ViewId.ConnectorRules]: ViewType.AgGrid,
  [ViewId.ViewPresets]: ViewType.AgGrid,
  [ViewId.OutputSettings]: ViewType.AgGrid,
  [ViewId.CronJobs]: ViewType.AgGrid,
  [ViewId.AdminOperations]: ViewType.AgGrid,
  [ViewId.SolrServers]: ViewType.AgGrid,
  [ViewId.InfraHosts]: ViewType.AgGrid,
  [ViewId.InfraHostFindings]: ViewType.AgGrid,
  [ViewId.LogEventStats]: ViewType.AgGrid,
  [ViewId.ObjectViewMainMenu]: ViewType.ObjectView,
};

/** View families whose views save named presets and show the toolbar preset picker. */
export const NAMED_PRESET_VIEW_TYPES: readonly ViewType[] = [ViewType.AgGrid];
